module.exports = __webpack_public_path__ + "img/gzt_05.6ab11f79.png";